import { FC } from "react";
import ManageUsers from "features/manageUsers/ManageUsers";

const ManageUsersPage: FC = () => {
  return <ManageUsers />;
};

export default ManageUsersPage;
